'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMonthAndDayText = getMonthAndDayText;
exports.getMonthAndDayTextFromGroup = getMonthAndDayTextFromGroup;
exports.getVerboseDateText = getVerboseDateText;
exports.getVerboseDateTextFromGroup = getVerboseDateTextFromGroup;
exports.getUrlFromGroup = getUrlFromGroup;
exports.makeGroupedChatHistory = makeGroupedChatHistory;

var _immutable = require('immutable');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _formatMediumDate = require('I18n/utils/formatMediumDate');

var _formatMediumDate2 = _interopRequireDefault(_formatMediumDate);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _isEmailCapturePromptMessage = require('conversations-schema/pubnub-message/operators/isEmailCapturePromptMessage');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

var _labelDateUtils = require('./labelDateUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ONE_DAY = 24 * 60 * 60 * 1000;

function getMonthAndDayText(message) {
  var timestamp = (0, _commonMessageFormatGetters.getTimestamp)(message);
  return (0, _formatMediumDate2.default)(timestamp, 'userTz');
}

function getMonthAndDayTextFromGroup(group) {
  var firstMessage = group.first();
  return getMonthAndDayText(firstMessage);
}

function getVerboseDateText(message) {
  var timestamp = (0, _commonMessageFormatGetters.getTimestamp)(message);
  var momentTimestamp = _I18n2.default.moment(timestamp);
  var olderThanOneDay = _I18n2.default.moment() - momentTimestamp > ONE_DAY;

  return olderThanOneDay ? momentTimestamp.format('MMMM DD, h:mm A') : (0, _labelDateUtils.getI18nDateMessage)(momentTimestamp);
}

function getVerboseDateTextFromGroup(group) {
  var firstMessage = group.first();
  return getVerboseDateText(firstMessage);
}

function getUrlFromGroup(group) {
  var visitorMessages = group.filter(function (message) {
    return (0, _commonMessageFormatGetters.getSenderType)(message) === _senderTypes.VISITOR;
  });
  var firstMessage = visitorMessages.first();
  return (0, _pubnubMessageGetters.getUrl)(firstMessage);
}

function oneIsEmailCapturePrompt(messageA, messageB) {
  return (0, _isEmailCapturePromptMessage.isEmailCapturePromptMessage)(messageA) || (0, _isEmailCapturePromptMessage.isEmailCapturePromptMessage)(messageB);
}

function areFromSameSender(messageA, messageB) {
  return (0, _commonMessageFormatGetters.getSenderType)(messageA) === (0, _commonMessageFormatGetters.getSenderType)(messageB) && (0, _commonMessageFormatGetters.getSenderId)(messageA) === (0, _commonMessageFormatGetters.getSenderId)(messageB);
}

function areWithinOneMinute(messageA, messageB) {
  var roundedMomentA = _I18n2.default.moment((0, _commonMessageFormatGetters.getTimestamp)(messageA)).startOf('minute');
  var roundedMomentB = _I18n2.default.moment((0, _commonMessageFormatGetters.getTimestamp)(messageB)).startOf('minute');

  return roundedMomentA.isSame(roundedMomentB);
}

function areConversationalMessages(messageA, messageB) {
  return (0, _messageTypeComparators.isConversationalMessage)(messageA) && (0, _messageTypeComparators.isConversationalMessage)(messageB);
}

function groupMessages(list) {
  var groups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _immutable.List)([(0, _immutable.List)()]);

  if (list.size === 0) {
    return groups;
  }

  var listHead = list.first();
  var nextList = list.shift();

  var groupsTail = groups.last();
  var firstInTail = groupsTail.first();
  var nextGroups = groups.pop();

  var shouldAddToLastGroup = groupsTail.size === 0 || areFromSameSender(listHead, firstInTail) && areWithinOneMinute(listHead, firstInTail) && areConversationalMessages(listHead, firstInTail) && !oneIsEmailCapturePrompt(listHead, firstInTail);

  var groupsToPass = shouldAddToLastGroup ? nextGroups.push(groupsTail.push(listHead)) : nextGroups.push(groupsTail, (0, _immutable.List)([listHead]));

  return groupMessages(nextList, groupsToPass);
}

function makeGroupedChatHistory(historySet) {
  var historyList = historySet.toList();

  return groupMessages(historyList);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/utils/chatHistoryGroups.js
// module id = 1148
// module chunks = 2 3